import { useEffect } from 'react';

import Layout from './Steps/Individual/Components/Layout';
import { StateMachineProvider, createStore } from 'little-state-machine';
import { useParams } from 'react-router-dom';
import { fetchRoster } from '../../../Redux/slices/rosters';
import { useDispatch } from 'react-redux';

createStore({});

function Individual() {
  const dispatch = useDispatch();
  const { id, edit: isEdit } = useParams();
  useEffect(() => {
    if (isEdit) {
      dispatch(fetchRoster(`/profile/resource-person/${id}/`));
    }
  }, []);

  return (
    <StateMachineProvider>
      <Layout />
    </StateMachineProvider>
  );
}

export default Individual;
